var _mask, _path, _path2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShareSms(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 44,
    viewBox: "0 0 42 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-outside-1_14656_59524",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 42,
    height: 44,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    width: 42,
    height: 44
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 21C1 9.95431 9.95431 1 21 1C32.0457 1 41 9.95431 41 21C41 32.0457 32.0457 41 21 41C9.95431 41 1 32.0457 1 21Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 21C1 9.95431 9.95431 1 21 1C32.0457 1 41 9.95431 41 21C41 32.0457 32.0457 41 21 41C9.95431 41 1 32.0457 1 21Z",
    fill: "#90A8C1",
    fillOpacity: 0.15
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 21C0 9.40202 9.40202 0 21 0C32.598 0 42 9.40202 42 21H40C40 10.5066 31.4934 2 21 2C10.5066 2 2 10.5066 2 21H0ZM42 23C42 34.598 32.598 44 21 44C9.40202 44 0 34.598 0 23L2 21C2 30.3888 10.5066 38 21 38C31.4934 38 40 30.3888 40 21L42 23ZM21 44C9.40202 44 0 34.598 0 23V21C0 9.40202 9.40202 0 21 0V2C10.5066 2 2 10.5066 2 21C2 30.3888 10.5066 38 21 38V44ZM21 0C32.598 0 42 9.40202 42 21V23C42 34.598 32.598 44 21 44V38C31.4934 38 40 30.3888 40 21C40 10.5066 31.4934 2 21 2V0Z",
    fill: "#90A8C1",
    fillOpacity: 0.3,
    mask: "url(#path-1-outside-1_14656_59524)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14656_59524)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.777 9.33595C17.8255 9.33012 14.182 11.4686 12.2605 14.9219C10.339 18.3753 10.4428 22.5998 12.5312 25.954L10.5 31.5026L16.0475 29.4715C19.9722 31.904 25.0052 31.596 28.6032 28.7015C32.2012 25.807 33.5813 20.9571 32.046 16.6019C30.5118 12.2456 26.3947 9.33362 21.777 9.33595V9.33595Z",
    stroke: "#FAFAFA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14656_59524"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(7 7)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareSms);
export default __webpack_public_path__ + "static/media/ShareSMS.65d101d18af02be5286155f632e2f39e.svg";
export { ForwardRef as ReactComponent };